import { url } from "./common";

// ---- Sub-shapes ----

/** Sanity's `_key`: stable across edits, so it survives reordering. */
type SanityKey = string;

export type HandbookChecklistItem = {
  key: SanityKey;
  text: string;
};

export type HandbookFaqEntry = {
  key: SanityKey;
  question: string;
  /** Plain text — answers carry no links or formatting. */
  answer: string;
};

export type HandbookVideo = {
  key: SanityKey;
  title: string;
  description: string | null;
  url: string;
  thumbnailUrl: string | null;
};

export type HandbookGuideLink = {
  key: SanityKey;
  label: string;
  /** An uploaded PDF or an external page — Sanity allows exactly one.
   * Buttons without a target are dropped by the api. */
  href: string;
};

export type HandbookGuide = {
  key: SanityKey;
  title: string;
  description: string | null;
  links: HandbookGuideLink[];
};

/**
 * Title and color come from the referenced spark, resolved by the api. A plan
 * without a spark or without a pdf is dropped there, so only `color` — which
 * the spark itself may not carry — can be absent.
 */
export type HandbookModerationPlan = {
  key: SanityKey;
  title: string;
  color: string | null;
  href: string;
};

// ---- Entity ----

/**
 * The teacher manual, edited as a single Sanity document. Section headings
 * ("Hi!", "Checkliste", …) are not part of it — those are fixed labels in the
 * frontend.
 */
export type Handbook = {
  checklist: HandbookChecklistItem[];
  faq: HandbookFaqEntry[];
  videos: HandbookVideo[];
  guides: HandbookGuide[];
  moderationPlans: HandbookModerationPlan[];
};

// ---- Models ----

export const handbookModels = {
  HANDBOOK: url<Handbook>(`/handbook`),
};
